<template>
  <div>
    <input v-model="model" :max="max" :min="min" class="threesixty-view" type="range" v-bind="$attrs"/>
  </div>
</template>

<script setup>
const props = defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: 2,
  },
  bgTransparent: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit("update:modelValue", Number(val) || 0);
    emit("change", Number(val) || 0);
  },
});
</script>

<style scoped>
.threesixty-view {
  width: 300px;
  -webkit-appearance: none;
  outline: none;
  display: block;
  margin: 15px auto;
  background: repeating-linear-gradient(
      90deg,
      #9273d4,
      #9273d4 1px,
      transparent 0,
      transparent 5px
  ) 50% no-repeat,
  repeating-linear-gradient(
      90deg,
      #9273d4,
      #9273d4 2px,
      transparent 0,
      transparent 25px
  ) 50% no-repeat;
  background-size: 98% 10px, 85% 40px;
}

.threesixty-view::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  background: #9273d4;
  border: 1px solid #9273d4 !important;
  border-radius: 50%;
  cursor: pointer;
}
</style>
